var _style, _metadata, _path, _path2, _path3, _path4, _path5, _g, _polygon, _polygon2, _path6, _path7, _g2, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "3.39131in",
    height: "1.4912in",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3385.71 1488.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:#FEFEFE;stroke-width:1.48;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2.61313}\r\n    .str5 {stroke:#FEFEFE;stroke-width:1.48;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2.61313}\r\n    .str2 {stroke:#FEFEFE;stroke-width:1.48;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2.61313}\r\n    .str1 {stroke:#FEFEFE;stroke-width:1.48;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2.61313}\r\n    .str3 {stroke:#FEFEFE;stroke-width:1.48;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2.61313}\r\n    .str4 {stroke:#FEFEFE;stroke-width:1.48;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2.61313}\r\n    .fil8 {fill:#FEFEFE}\r\n    .fil6 {fill:#E6E7E8}\r\n    .fil4 {fill:#BDBFC1}\r\n    .fil5 {fill:#96989A}\r\n    .fil11 {fill:#4B4B4D}\r\n    .fil0 {fill:#ED3237}\r\n    .fil7 {fill:#AC3335}\r\n    .fil10 {fill:#999999}\r\n    .fil1 {fill:#FEFEFE;fill-rule:nonzero}\r\n    .fil3 {fill:#ED3237;fill-rule:nonzero}\r\n    .fil9 {fill:#B3B3B4;fill-rule:nonzero}\r\n    .fil2 {fill:url(#id20)}\r\n  ")), /*#__PURE__*/React.createElement("mask", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    x1: 569.07,
    y1: 549.2,
    x2: 396.71,
    y2: 1254.78
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "white"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#id1)"
    },
    x: 292.8,
    y: 347.81,
    width: 803.34,
    height: 569.55
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id3",
    gradientUnits: "userSpaceOnUse",
    x1: 2757.62,
    y1: 1046.53,
    x2: 2934.06,
    y2: 322.78
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "white"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#id3)"
    },
    x: 1255.11,
    y: 316.88,
    width: 2112.39,
    height: 701.13
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id5",
    gradientUnits: "userSpaceOnUse",
    x1: 2073.35,
    y1: 1753.2,
    x2: 2005.22,
    y2: 130.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "white"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#id5)"
    },
    x: 348.29,
    y: 595.83,
    width: 2454.44,
    height: 333.92
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id7",
    gradientUnits: "userSpaceOnUse",
    x1: 870.8,
    y1: 232,
    x2: -241.47,
    y2: 302.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "white"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#id7)"
    },
    x: 19.3,
    y: 32.34,
    width: 1120.14,
    height: 840.42
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id8"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id9",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.08,
    y1: 983.02,
    x2: 1977.08,
    y2: 1203.49
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "white"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#id9)"
    },
    x: 472.45,
    y: 1043.7,
    width: 536.49,
    height: 200.49
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id10"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id11",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.08,
    y1: 983.02,
    x2: 1977.08,
    y2: 1203.49
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "white"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#id11)"
    },
    x: 1006.13,
    y: 1043.7,
    width: 544.31,
    height: 200.49
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id12"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id13",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.08,
    y1: 983.02,
    x2: 1977.08,
    y2: 1203.49
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "white"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#id13)"
    },
    x: 1556.94,
    y: 1043.7,
    width: 543.44,
    height: 219.31
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id14"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id15",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.08,
    y1: 983.02,
    x2: 1977.08,
    y2: 1203.49
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "white"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#id15)"
    },
    x: 2023.16,
    y: 1043.7,
    width: 530.41,
    height: 200.49
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id16"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id17",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.08,
    y1: 983.02,
    x2: 1977.08,
    y2: 1203.49
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "white"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#id17)"
    },
    x: 2528.63,
    y: 1043.7,
    width: 536.49,
    height: 200.49
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id18"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id19",
    gradientUnits: "userSpaceOnUse",
    x1: 828.47,
    y1: 183.13,
    x2: 607.63,
    y2: 972.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "white"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#id19)"
    },
    x: 333.99,
    y: 379.67,
    width: 735.84,
    height: 422.36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id20",
    gradientUnits: "userSpaceOnUse",
    x1: 1370.26,
    y1: 637.42,
    x2: 1725.42,
    y2: 733.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#C7C8C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458824,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#B4B6B5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1874835957872"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M2796.16 461.55c-230.44,-69.46 -446.48,-103.72 -645.92,-97.9 -208.75,6.09 -439.25,57.27 -609.08,156.84 -66.9,39.22 -44.22,65.84 3.35,85.7 -112.7,-7.7 -235.42,-8.4 -368.16,-2.08 478.15,-245.79 825.92,-329.99 1205.76,-299.13 320.41,26.04 633.9,134.9 946.74,205.73 44.63,10.11 75.17,15.7 44.39,78.68 -22.12,45.25 -73.77,92.84 -95.01,147.04l-30.44 187.02c-6.05,62.27 -67.39,127.43 -127.89,195.51 56.99,-83.88 72.47,-212.52 76.07,-274.3 2.66,-45.68 -16.32,-63.47 -43.95,-61.67 -110.44,4.83 -165.65,7.26 -165.65,7.26 95.75,-23.5 167.5,-68.83 215.22,-135.99 30.34,-35.74 29.89,-57.28 -9.12,-66.65 -264.22,-84.05 -396.29,-126.08 -396.29,-126.08z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M97.48 374.1c42.25,-6.95 42.25,-38.78 42.25,-38.78 -26.46,2.34 -37.35,19.9 -51.02,32.17 -2.37,-40.99 41.48,-68.85 79.93,-79.75 80.95,-22.95 182.43,-3.6 248.26,-26.04 0,0 -9.86,30.37 -25.98,40.85 44.69,14.35 90.54,38.46 128.93,61.93 241.43,-157.71 639.57,-364.48 639.57,-364.48 1.19,80.56 -17.11,194.76 -122.88,280.58 -93.54,75.89 -301.77,158.71 -577.85,295.66 -144.78,71.82 -233.18,223.8 -190,430.39 -96.6,-138.4 -55.33,-386.74 106.69,-535.72 -54.56,34.2 -105.26,72.92 -137.98,139.76 -1.06,-33.59 -4.45,-71.24 -14.85,-96.04 -45.84,-109.37 -202.03,-62.95 -168.97,-22.36 -51.4,-6.79 -105.97,-106.1 43.9,-118.17z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M2162.64 415.37l-0.03 0c0,0 0,0 0.02,0 0.01,0 0.01,0 0.02,0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M3367.02 556.64l0.07 -0.44c-0.02,0.14 -0.05,0.29 -0.07,0.44z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M2114.86 642.97c-173.52,-2.33 -304.56,-9.89 -393.14,-22.66 -258.43,-37.27 -88.24,-109.15 68.07,-156.16 108.14,-32.52 232.41,-48.77 372.82,-48.78l0.03 0c19.99,0 40.34,0.33 60.98,0.99 -32.78,86.09 -69.04,161.63 -108.76,226.61z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "fil1 str0",
    points: "1050.58,871.45 1009.75,1032.77 942.8,932.92 769.06,932.92 748.41,1014.51 843.84,1014.51 922.76,970.74 880.21,1138.85 825.17,1088.28 729.74,1088.28 708.95,1170.43 882.69,1170.43 1008.95,1063.69 963.26,1244.19 472.45,1244.19 584.66,1157.95 635.23,958.16 566.79,871.45 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str1",
    d: "M1507.73 871.45l-76.24 68.18 48 217.29 70.94 87.27 -310.23 0 104.89 -76.56 -4.7 -25.71 -141.73 0 -17.53 25.71 54.93 76.56 -229.95 0 94.55 -87.27 156.39 -217.29 -40.49 -68.18 291.15 0zm-200.6 108.32l-68.95 100.68 89.83 0 -20.88 -100.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str2",
    d: "M2052.13 871.17l-41.7 164.76c-41.65,-71.63 -97.1,-107.48 -166.48,-107.48 -31.03,0 -58.29,12.11 -81.72,36.33 -23.43,24.22 -40.64,57.93 -51.58,101.15 -21.5,84.94 1.92,127.42 70.2,127.42 31.27,0 59.1,-9.68 83.35,-29.15l5.11 -20.21 -78.18 -88.11 309.25 0 -112.13 88.11 -30.13 119.03 -44.41 -39.31c-57.55,25.98 -113.59,38.93 -168.2,38.93 -65.63,0 -115.92,-18.53 -150.96,-55.7 -35.01,-37.07 -45.59,-83.08 -31.68,-138.04 14.5,-57.28 51.22,-106.55 110.18,-147.81 58.89,-41.26 122.07,-61.94 189.36,-61.94 57.63,0 102.81,16.3 135.67,48.99l54.05 -36.97z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1 str3",
    points: "2553.57,1044.69 2503.07,1244.19 2023.16,1244.19 2135.21,1157.85 2185.54,959 2117.5,871.45 2425.27,871.45 2312.98,959 2259.47,1170.43 2411.23,1170.43 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1 str4",
    points: "3106.75,871.45 3065.93,1032.77 2998.97,932.92 2825.23,932.92 2804.58,1014.51 2900.01,1014.51 2978.93,970.74 2936.39,1138.85 2881.34,1088.28 2785.91,1088.28 2765.12,1170.43 2938.86,1170.43 3065.12,1063.69 3019.43,1244.19 2528.63,1244.19 2640.84,1157.95 2691.4,958.16 2622.97,871.45 "
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "2622.17,1353.11 3009.71,1353.11 2996.48,1381.28 2608.94,1381.28 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "448.03,1353.11 813.35,1353.11 800.13,1381.28 434.81,1381.28 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fil1 str5",
    d: "M1139.12 1487.99c20.59,0 34.28,-12.72 39.72,-20.39l-11.84 -17.57c-4.07,5.25 -10.23,10.7 -20.93,10.7l-76.92 0c-13.93,0 -14.51,-5.85 -10.83,-17.56l15.43 -49.06c4.13,-13.12 9.76,-17.56 21.88,-17.56l75.91 0c10.5,0 13.69,5.25 14.4,10.7l22.95 -17.77c-0.82,-7.67 -6.31,-20.39 -26.9,-20.39l-77.93 0c-33.11,0 -46.44,10.3 -57.36,45.02l-15.36 48.86c-10.86,34.53 -4.06,45.02 29.05,45.02l78.74 0zm375.47 0l-32.43 -138.9 -28.46 0 -119.79 138.9 31.09 0 27.52 -32.3 83.78 0 7.2 32.3 31.09 0zm-41.73 -54.1l-62.99 0 49.59 -57.54 13.4 57.54zm372.18 54.1l-37.06 -45.83c34.32,0 49.45,-7.67 60.12,-41.59l2.67 -8.48c9.9,-31.5 3.22,-43 -26.25,-43l-113.46 0 -43.68 138.9 27.45 0 14.28 -45.42 43.81 0 33.76 45.42 38.36 0zm-4.89 -84.59c-3.81,12.11 -8.98,16.35 -18.67,16.35l-85.19 0 13.52 -43 85.2 0c11.91,0 11.49,6.46 7.24,19.99l-2.09 6.66zm216.52 -3.63l25.56 -29.27 8.32 -26.45 -25.24 0 -9.21 29.27 8.07 0 -14.99 22.01 7.49 4.44zm325.95 43.2c7.68,-24.43 -0.67,-35.73 -35.19,-35.73l-55.52 0c-13.32,0 -15.77,-4.44 -12.34,-15.34 3.43,-10.9 8.6,-15.14 21.92,-15.14l93.88 0c4.13,-9.28 8.2,-18.37 12.13,-27.66l-97.31 0c-33.72,0 -48.37,11.31 -57.07,38.97l-1.46 4.64c-8,25.44 -1.04,37.35 32.27,37.35l56.32 0c14.33,0 17.23,3.64 13.55,15.34 -3.75,11.91 -9.07,15.34 -23.8,15.34l-94.48 0c-3.46,9.09 -7.13,18.17 -10.39,27.25l98.11 0c33.11,0 48.59,-10.7 57.86,-40.17l1.53 -4.85z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M2259.73 667.82c-0.04,-18.08 1.45,-37.65 2.39,-56.02 0.93,-18.23 1.84,-37.44 3.34,-55.76l6.39 -85.86c0.68,-7.86 2.7,-21.48 2.2,-28.66 -3.44,5.27 -8.84,22.01 -11.44,29.05 -10.29,27.88 -20.38,64.58 -29.32,93.23 -11.76,37.68 -21.01,69.71 -36.36,106.23 -0.95,2.24 -5.13,13.01 -7.27,13.47 -189.21,-0.17 -375.39,-10.91 -561.92,-20.97 -311.79,-16.8 -777.39,-36.04 -1076.29,70.58 -41.15,14.68 -89.99,37.52 -123.38,61.45 -11.29,8.09 -31.97,23.89 -40.68,33.48 -6,6.6 -11.36,12.1 -17.16,20.04 -33.61,46.05 -50.66,114.68 -53.47,171.08 -0.64,12.83 -3.22,54.29 -0.96,64.43 6.71,-32.14 17.01,-66.36 29.05,-95.68 17.69,-43.08 39.03,-76.06 70.82,-107.76 9,-8.98 19.48,-17.52 29.31,-25.65 19.65,-16.26 61.46,-39.46 89.16,-50.61 66.41,-26.74 122.32,-40.47 193.63,-52.73 88.95,-15.29 132.64,-20.04 223.06,-23.19 81.23,-2.83 161.48,-1.16 242.56,-0.7 39.87,0.23 79.69,1.89 119.68,2.78 117.82,2.63 236.54,7.92 354.66,10.97 80.11,2.07 159.92,3.59 240.31,5.46 8.36,0.99 24.69,0.54 33.95,0.51l107.15 0.45c47.31,-0.02 94.75,-0.55 141.94,-1.8 90.78,-2.41 181.5,-6.85 271,-16.45 108.48,-11.63 250.66,-33.77 343.82,-89.32 8.04,-4.8 14.46,-9.37 21.81,-14.55 6.76,-4.78 14.57,-10.99 19.86,-16.54 14.76,-15.5 20.27,-20.27 31.43,-40.93 -2.99,0.4 -11.86,4.88 -15.54,6.34 -48.34,19.25 -66.69,25.84 -119.49,42.46 -91.5,28.8 -218.26,47.94 -311.26,56.61 -15.06,1.4 -159.94,11.79 -173.25,9.11l0.25 -14.53z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    style: {
      mask: "url(#id0)"
    },
    d: "M292.8 917.36l13.43 -25.9c66.84,-169.44 226.54,-205.7 396.62,-248.07 150.46,-37.48 265.06,-54.27 343.14,-173.69 16.65,-25.45 49.3,-84.17 50.14,-121.89l-118.28 49.1c-107.6,42.17 -249.68,112.17 -358.35,158.54 -21.28,9.08 -38.09,15.06 -58.95,24.75 -111.32,51.72 -180.65,77.24 -236.61,196.35 -17.69,37.66 -31.15,87.31 -31.15,140.81z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M154.55 311.71c0,0 -0.19,-0.02 -0.51,-0.1 0.17,0.04 0.34,0.07 0.51,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1",
    className: "fil1",
    d: "M153.69 313.28l0.78 -3.33 0.04 0.01 -0.07 -0.02 0.05 0.01 0.14 0.04 -0.06 -0.02 0.06 0.01 0.02 0.01 -0.11 -0.02 0.02 0 0.05 0.01 0.02 0 0.02 0 0.05 0.01 0.06 0.01 0.06 0.02 0.02 0 -0.19 -0.04 0.02 0 0.05 0.01 0.05 0.01 0.01 0 0.01 0 0.06 0.01 -0.33 -0.03 0.01 0 0.55 0.09 0 0 -0.53 -0.09 0 0 0 0 0 0 0.17 0.01 -0.35 3.4 0.17 0.01 -0 0 0 0 -0 0 -0.55 -0.09 -0 -0 0.53 0.09 -0.01 0 -0.34 -0.03 0.04 0 -0.01 0 -0.01 -0 0.03 0.01 0.02 0 -0.02 0 -0.22 -0.04 -0.02 -0 0.03 0.01 0.02 0 0.01 0 -0.02 -0 -0.02 -0 0 0 -0.02 -0 -0.16 -0.03 -0.02 -0.01 0.01 0 -0.11 -0.03 0.09 0.02 -0 0 -0.14 -0.04 -0.02 -0 0.78 -3.33 -0.7 3.35zm1.03 -3.27l-0.51 3.38 -0.09 -0.02 -0.02 -0 0.19 0.04 0.01 0 -0.2 -0.03 -0.06 -0.02 -0.02 -0 0.19 0.04 -0.02 0 -0.22 -0.04 -0.02 -0 -0.02 -0 0.19 0.04 -0.02 0 -0.22 -0.04 -0.02 -0 -0.02 -0 0.21 0.04 -0.02 0 -0.24 -0.04 -0.02 -0 -0.02 -0 0.19 0.04 -0.02 0 -0.22 -0.04 -0.02 -0 -0.02 -0 0.19 0.04 -0.02 0 -0.22 -0.04 -0.02 -0 0.05 0.01 0.7 -3.35 0.08 0.02 0.02 0 -0.19 -0.04 0.02 0 0.22 0.04 0.02 0 0.02 0 -0.19 -0.04 0.02 0 0.22 0.04 0.02 0 0.02 0 -0.21 -0.04 0.02 0 0.24 0.04 0.02 0 0.02 0 -0.19 -0.04 0.02 0 0.22 0.04 0.02 0 0.02 0 -0.19 -0.04 0.02 0 0.22 0.04 0.02 0 -0.03 -0.01 -0.16 -0.02 0.04 0 0.22 0.04 0.02 0 -0.06 -0.01 -0.51 3.38 0.35 -3.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    style: {
      mask: "url(#id2)"
    },
    d: "M3184.25 1018.02c17.24,-56.82 26.56,-118.15 29.89,-175.22 1.76,-29.81 -4.47,-61.68 -32.68,-73.58 -7.04,-2.97 -14.81,-4.32 -22.86,-4.32 -1.53,0 -3.1,0.05 -4.67,0.15 -19.55,0.85 -39.13,1.71 -58.71,2.57 46.28,-24.57 87.5,-58.31 120.14,-103.93 14.77,-17.5 30.07,-40.41 25.02,-61.7 -4.48,-18.87 -22.66,-27.38 -40.46,-31.74 -98.7,-31.4 -197.4,-62.81 -296.1,-94.21 -24.74,-7.87 -49.49,-15.75 -74.23,-23.61 -8.54,-2.71 -17.1,-5.57 -25.66,-8.16 -190.52,-57.42 -396.98,-99.24 -606.3,-99.24 -14.99,0 -29.98,0.22 -45,0.66 -197.2,5.75 -435.56,52.29 -618.8,159.72 -23.24,13.63 -52.86,35.28 -52.68,63.59 0.04,5.71 1.34,10.92 3.56,15.68 -43.81,-1.93 -87.85,-2.83 -132.04,-2.83 -32.45,0 -64.99,0.48 -97.57,1.4 134.13,-66.15 271.52,-125.68 411.09,-171.4 140.84,-46.14 281.69,-77.05 424.33,-89.09 47.32,-3.99 94.34,-5.88 141.04,-5.88 49.08,0 97.8,2.09 146.19,6.02 203.43,16.53 399.79,65.68 591.72,115.99 117.16,30.72 233.96,62.51 352.71,89.38 10.44,2.38 37.66,7.3 43.55,16.15 1.91,2.83 2.09,7.06 1.36,11.78l-0.07 0.44c-1.63,9.64 -7.04,21.21 -9.98,27.19 -6.83,13.97 -16.48,27.65 -25.85,40.35 -11.45,15.48 -23.36,30.6 -34.52,46.27 -13.92,19.59 -26.75,40.1 -35.33,61.96 -0.54,1.39 -0.89,2.6 -1.12,4.02l-30.44 187.02c-0.07,0.42 -0.13,0.78 -0.17,1.19 -2.85,29.75 -21.16,60.21 -39.57,85.56 -1.89,2.61 -3.84,5.22 -5.8,7.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    style: {
      mask: "url(#id4)"
    },
    d: "M2236.56 667.53c-0.01,-14.46 0.81,-28.74 1.61,-42.73 0.29,-5.03 0.58,-9.98 0.78,-13.98l0.77 -14.99c-8.5,27.35 -16.76,52.87 -28.8,81.55l-0.38 0.94 -0.03 -0.01c-2.5,6.12 -8.88,21.59 -20.71,24.12l-4.01 0.38c-178.55,-0.16 -353.42,-9.63 -528.41,-19.1l-34.49 -1.87c-155.61,-8.38 -349.56,-17.38 -541.39,-10.99 -190.88,6.36 -379.98,27.93 -527.4,80.51 -21.08,7.52 -44.21,17.23 -66.09,28.13 -19.33,9.63 -37.63,20.15 -52.52,30.83 -6.64,4.76 -16.1,11.83 -23.89,18.25 -5.57,4.58 -10.64,9.07 -13.76,12.51l-0.08 0 -3.06 3.34 0 0.08c-4.58,4.98 -8.87,9.65 -12.74,14.95 -14.35,19.65 -25.52,44.23 -33.67,70.32 2.15,-3.59 4.35,-7.11 6.63,-10.58 12.2,-18.63 26.33,-35.82 43.27,-52.72 9.19,-9.17 19,-17.27 28.38,-25.03l2.22 -1.84c10.35,-8.56 26.16,-18.78 43,-28.34 17.48,-9.92 36.3,-19.25 51.3,-25.29 33.97,-13.68 65.29,-24.04 97.25,-32.56 31.92,-8.5 64.24,-15.11 100.31,-21.32 44.64,-7.67 78.13,-12.72 112.27,-16.3 33.64,-3.52 67.59,-5.52 113.44,-7.11 64.14,-2.23 127.82,-1.66 191.77,-1.1 17.22,0.15 34.49,0.31 51.48,0.4 26.47,0.15 52.31,0.9 78.18,1.65 14.22,0.41 28.46,0.83 41.8,1.12 64.63,1.44 128.68,3.65 192.76,5.85 54.3,1.87 108.63,3.75 161.98,5.12 49.73,1.29 98.74,2.35 147.83,3.41 30.75,0.66 61.54,1.33 92.41,2.05l1.89 0.07c5.84,0.69 16.57,0.57 25,0.49 37.91,-0.31 75.96,0.24 113.89,0.4 23.47,-0.01 47.06,-0.15 70.72,-0.44 23.4,-0.29 46.97,-0.74 70.7,-1.36 44.71,-1.19 89.78,-2.9 135.37,-5.53 44.83,-2.59 89.55,-6.08 134.03,-10.85 53.62,-5.75 115.53,-14.09 175.39,-27.81 59.04,-13.54 115.98,-32.28 160.56,-58.86 3.67,-2.19 7.12,-4.45 10.59,-6.81 -15.89,5.56 -32.87,11.07 -56.86,18.62 -42.04,13.23 -91.61,24.49 -142.1,33.67 -60.31,10.97 -121.83,18.91 -173.17,23.7 -9.78,0.9 -72.4,5.49 -119.66,7.97 -28.46,1.49 -52.42,2.18 -59.11,0.83l-15.79 -3.18 0.52 -30.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil9",
    style: {
      mask: "url(#id6)"
    },
    d: "M159.03 335.7c0,0.13 -0.09,47.06 -56.97,57.21 -0.99,0.24 -2.02,0.4 -3.07,0.49 -42.7,3.44 -65.34,13.64 -74.86,25.97 -3.36,4.35 -4.82,9 -4.83,13.57 -0.01,5.25 1.71,10.75 4.6,15.96 2.82,5.07 6.57,9.7 10.86,13.55l1.03 -1.68c6.46,-10.05 18.17,-18.59 32.92,-24.4 12.92,-5.09 28.8,-8.35 45.75,-8.75 46.03,-1.1 100.42,18.7 125.95,79.62 5.26,12.53 8.89,27.68 11.38,43.85 10.29,-13.34 21.41,-25.4 33.15,-36.52 24.34,-23.02 51.16,-41.72 78.89,-59.16 7.84,-5.85 19,-4.93 25.76,2.43 7.23,7.86 6.72,20.09 -1.14,27.32 -76.55,70.38 -125.04,163.94 -143.51,256.69 -8.95,44.89 -10.84,89.45 -5.46,130.92 3.39,-47.46 14.36,-91.01 31.66,-130.21 36.07,-81.71 99.48,-144.2 178.98,-183.64 87.62,-43.46 170.01,-82.21 243.78,-116.89 153.31,-72.09 268.73,-126.36 330.44,-176.42 49.72,-40.35 78.89,-87.38 95.49,-133.78 12.31,-34.44 17.78,-68.59 19.59,-99.48 -95.59,50.33 -407.11,216.46 -608.99,348.34l-0.01 -0.02c-6.05,3.95 -14.07,4.34 -20.65,0.33 -20.49,-12.53 -42.95,-25.15 -65.89,-36.16 -19.32,-9.28 -39.21,-17.56 -58.88,-23.88 -4.09,-1.31 -7.77,-3.99 -10.29,-7.87 -4.78,-7.37 -3.9,-16.78 1.55,-23.11 -24.23,2.85 -50.36,3.34 -77.17,3.86 -42.5,0.81 -86.88,1.66 -125.24,12.54 -9.14,2.59 -18.59,6.24 -27.41,10.86 7.48,2.77 12.75,10.05 12.58,18.48z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1874835936368"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "fil10",
    style: {
      mask: "url(#id8)"
    },
    points: "904.29,1043.7 880.21,1138.85 825.17,1088.28 729.74,1088.28 708.95,1170.43 882.69,1170.43 1008.95,1063.69 963.26,1244.19 472.45,1244.19 584.66,1157.95 613.57,1043.7 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil10",
    style: {
      mask: "url(#id10)"
    },
    points: "1454.49,1043.7 1479.5,1156.92 1550.44,1244.19 1240.2,1244.19 1345.1,1167.63 1340.4,1141.93 1198.67,1141.93 1181.15,1167.63 1236.08,1244.19 1006.13,1244.19 1100.68,1156.92 1182.17,1043.7 1263.35,1043.7 1238.18,1080.46 1328.01,1080.46 1320.38,1043.7 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10",
    style: {
      mask: "url(#id12)"
    },
    d: "M1717.1 1043.7c-2.35,7.11 -4.5,14.51 -6.45,22.22 -21.5,84.94 1.92,127.42 70.2,127.42 31.27,0 59.1,-9.68 83.35,-29.15l5.11 -20.21 -78.18 -88.11 309.25 0 -112.13 88.11 -30.13 119.03 -44.41 -39.31c-57.55,25.98 -113.59,38.93 -168.2,38.93 -65.63,0 -115.92,-18.53 -150.96,-55.7 -35.01,-37.07 -45.59,-83.08 -31.68,-138.04 2.17,-8.58 4.85,-16.98 8.02,-25.2l146.21 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil10",
    style: {
      mask: "url(#id14)"
    },
    points: "2553.57,1044.69 2503.07,1244.19 2023.16,1244.19 2135.21,1157.85 2164.1,1043.7 2291.54,1043.7 2259.47,1170.43 2411.23,1170.43 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil10",
    style: {
      mask: "url(#id16)"
    },
    points: "2960.47,1043.7 2936.39,1138.85 2881.34,1088.28 2785.91,1088.28 2765.12,1170.43 2938.86,1170.43 3065.12,1063.69 3019.43,1244.19 2528.63,1244.19 2640.84,1157.95 2669.75,1043.7 "
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    style: {
      mask: "url(#id18)"
    },
    d: "M333.99 802.03c81.08,-106.97 213.01,-139.8 353.01,-174.6l11.23 -2.79c12.3,-3.07 27.87,-6.82 43.04,-10.48 125.26,-30.23 222.21,-53.62 288.53,-155.03 9.45,-14.45 24.23,-39.97 34.78,-65.62 1.91,-4.65 3.69,-9.28 5.25,-13.82l-84.94 35.25c-63.62,24.93 -138.73,59.34 -211.89,92.85 -51.5,23.59 -102.06,46.75 -145.94,65.47 -8.12,3.47 -15.86,6.59 -23.41,9.63 -11.39,4.59 -22.34,9.01 -35,14.89l-20.95 9.68c-95.37,43.93 -156.94,72.29 -206.27,177.29 -2.59,5.5 -5.07,11.28 -7.44,17.3z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1526.86 400.35l-32.96 -80.59 -77.57 31.73 9.23 22.57 51.98 -21.26 7.25 17.73c3.46,8.46 0.32,15.16 -14.99,21.42l-63.06 25.79c-12.9,5.27 -17.39,4.06 -25.22,-15.09l-18.29 -44.73c-5.6,-13.7 -3.55,-19.01 9.15,-24.2l68.3 -27.94c10.68,-4.37 17.25,-0.94 22.1,3.43l9.87 -24.73c-6.15,-6.42 -21.02,-15.16 -41.36,-6.84l-70.32 28.76c-34.25,14.01 -38.34,29.32 -24.74,62.57l19.94 48.76c14.17,34.66 27.24,41.31 61.5,27.3l58.83 -24.07c15.52,-6.34 21.16,-19 19.68,-27.8l7.73 16.59 22.97 -9.39zm340.13 -102.55l-114.1 -127.07 -29.88 7.01 -45.7 164.55 32.64 -7.65 10.27 -38.18 87.95 -20.63 26.18 29.63 32.64 -7.66zm-75 -42.33l-66.12 15.51 18.89 -68.15 47.23 52.65zm403.57 2.05l-58.48 -45.86c36.93,-2.3 50.11,-11.41 47.83,-47.92l-0.57 -9.12c-2.11,-33.89 -13.97,-45.59 -45.69,-43.61l-122.1 7.62 9.33 149.48 29.55 -1.84 -3.05 -48.88 47.15 -2.94 54.76 45.66 41.28 -2.58zm-39.57 -88.92c0.81,13.03 -3.03,17.85 -13.46,18.5l-91.69 5.72 -2.89 -46.28 91.69 -5.72c12.82,-0.8 14.99,6.05 15.9,20.6l0.45 7.17zm386.79 113.19l-64.74 -158.03 -30.5 -3.45 -98.36 139.61 33.31 3.76 22.51 -32.51 89.77 10.14 14.69 36.71 33.31 3.76zm-56.39 -65.08l-67.49 -7.63 40.71 -57.84 26.78 65.46zm367.15 130.6l19.22 -84.93 -81.74 -18.5 -5.38 23.78 54.78 12.4 -4.23 18.68c-2.02,8.92 -8.43,12.6 -24.57,8.95l-66.46 -15.04c-13.59,-3.08 -16.57,-6.65 -12,-26.83l10.67 -47.13c3.27,-14.44 8,-17.6 21.38,-14.58l71.98 16.3c11.25,2.55 14.67,9.13 16.13,15.48l22.28 -14.6c-1.36,-8.79 -8.52,-24.47 -29.97,-29.33l-74.1 -16.78c-36.09,-8.17 -48.22,2.03 -56.16,37.06l-11.63 51.38c-8.27,36.52 -1.38,49.46 34.71,57.63l62 14.04c16.35,3.7 28.23,-3.43 32.07,-11.49l-3.19 18.03 24.2 5.48zm304.99 80.39l7.48 -28.42 -110.74 -29.13 8.53 -32.42 107.58 28.3 6.15 -23.37 -107.58 -28.3 8.42 -32 110.74 29.13 7.53 -28.63 -139.16 -36.6 -38.1 144.84 139.16 36.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.92057ba8e5ff844e262918da59b3583f.svg";
export { ForwardRef as ReactComponent };